import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { SignageDisplaySettings } from '@shared/ui/organisms/settings/SignageSetting';
import { SignageDevicesSection } from './SignageDevicesSection';

export function WaypointScreensPanel() {
  const { t } = useTranslation();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.waypoint-screens-tab')}</HeadlineSmall>
      <SignageDisplaySettings />
      <SignageDevicesSection />
    </>
  );
}
